var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-base-card',{staticClass:"new-dashboard-instagram-card",attrs:{"hasBorder":false}},[_vm._t("default")],2),(_vm.$slots.action)?_c('div',[_vm._t("action")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }